import { motion } from "framer-motion";
import { formatCompactUsd, formatProgress } from "@/lib/format";
import { CHECKPOINTS, EnergyCheckpoints } from "./EnergyCheckpoints";

const percentageLabel = (progress) => {
  if (progress > 0 && progress < 0.001) return "<0.1%";
  if (progress > 0.999 && progress < 1) return ">99.9%";
  return formatProgress(progress);
};

export const EnergyChannel = ({ marketCap, target, progress, known, displayed, leadingX, feed, rocket = false }) => {
  const currentLabel = known ? `$${marketCap.toLocaleString("en-US", { maximumFractionDigits: 2 })}` : "—";
  const percent = known ? percentageLabel(progress) : "—";
  const hasEnergy = known && progress > 0;
  return (
    <div className="energy-channel" data-testid="energy-core-channel">
      <div className="energy-channel__meta">
        <div>
          <span className="energy-channel__caption" data-testid="energy-core-marketcap-label">CURRENT MARKET CAP</span>
          <span className="energy-channel__marketcap" data-testid="hero-unlock-ticker-marketcap">{currentLabel}</span>
        </div>
        <div className="energy-channel__readout">
          <span className="energy-channel__percent" data-testid="hero-unlock-ticker-percent">{percent}</span>
          <span className="energy-channel__caption" data-testid="energy-core-target-label">TARGET {formatCompactUsd(target)}</span>
        </div>
      </div>
      <div className="energy-channel__instrument">
        <div className="energy-track" role="progressbar" aria-label="Market-cap progress toward ecosystem unlock"
          aria-valuemin={0} aria-valuemax={100} aria-valuenow={known ? progress * 100 : undefined}
          aria-valuetext={known ? `${currentLabel} of ${formatCompactUsd(target)}; ${percent}` : "Market data unavailable"}
          data-testid="energy-core-track" data-progress={progress} data-has-energy={hasEnergy}>
          <motion.div className="energy-track__fill" style={{ scaleX: displayed }} data-testid="energy-core-fill">
            {hasEnergy && <span className="energy-track__motes" aria-hidden="true"><i /><i /></span>}
          </motion.div>
          {CHECKPOINTS.map(({ id, fraction }) => (
            <span key={id} className="energy-track__tick" style={{ left: `${fraction * 100}%` }}
              data-testid={`energy-core-tick-${id}`} data-position={fraction} data-reached={known && marketCap >= target * fraction} aria-hidden="true" />
          ))}
          {hasEnergy && !rocket && <motion.div className="energy-track__leader" style={{ x: leadingX }} aria-hidden="true" data-testid="energy-core-leading-node"><span /></motion.div>}
        </div>
        {hasEnergy && progress < 1 && <div className="energy-transfer" style={{ left: `${progress * 100}%`, width: `${(1 - progress) * 100}%` }} aria-hidden="true" data-testid="energy-core-transfer"><span /></div>}
      </div>
      <EnergyCheckpoints marketCap={marketCap} target={target} known={known} />
      <div className="energy-channel__footer">
        <span data-testid="energy-core-scale-start">$0</span>
        <span className="energy-feed" data-testid="hero-unlock-ticker-feed"><i aria-hidden="true" />{feed}</span>
      </div>
    </div>
  );
};